module.exports = __webpack_public_path__ + "media/assets/svgs/pinterest-8eb058c753dad530487c5c95d90f9990.svg";